import { colors } from '../theme';
import { gridSize } from '../theme/constants';
import { Field } from '../form';
import { jsx } from '@emotion/react';

const styles = {
  option: (css: any, { isFocused, isSelected, isDisabled }: any) => {
    let color;
    if (isDisabled) color = colors.N70;
    else if (isSelected) color = colors.N0;
    else if (isFocused) color = colors.G400;

    let backgroundColor;
    if (isDisabled) backgroundColor = undefined;
    // else if (isSelected) backgroundColor = colors.N500;
    else if (isSelected) backgroundColor = colors.N50;
    else if (isFocused) backgroundColor = colors.G50;

    const cursor = isDisabled ? 'not-allowed' : undefined;

    return {
      ...css,
      paddingTop: `${gridSize()*1.5}px`,
      paddingBottom:`${gridSize()*1.5}px`,
      backgroundColor,
      color,
      cursor,
    };
  },
   menuPortal: (css:any) => ({
      ...css,
      zIndex: 9999,
    }),
};

export default styles;
